import React from 'react';
import './Astrology.css';

function Astrology() {
  return (
    <div className="container">
      <h1 className="page-title">Астрология</h1>
      
      <section className="astrology-section">
        <div className="sign-banner">
          <div className="sign-icon">♑</div>
          <div className="sign-info">
            <h2>Козерог</h2>
            <p>22 декабря - 20 января</p>
            <p>Стихия: Земля</p>
            <p>Планета-управитель: Сатурн</p>
          </div>
        </div>
      </section>
      
      <section className="astrology-section">
        <h2>Характеристики Козерога</h2>
        <div className="card">
          <p>
            Козероги известны своей целеустремленностью, практичностью и дисциплиной. 
            Они обладают сильной внутренней решимостью и готовы усердно работать для достижения своих целей.
          </p>
          <div className="trait-grid">
            <div className="trait-card positive">
              <h3>Сильные стороны</h3>
              <ul>
                <li>Ответственность</li>
                <li>Надежность</li>
                <li>Амбициозность</li>
                <li>Дисциплинированность</li>
                <li>Терпение</li>
                <li>Преданность</li>
              </ul>
            </div>
            <div className="trait-card neutral">
              <h3>Слабые стороны</h3>
              <ul>
                <li>Упрямство</li>
                <li>Пессимизм</li>
                <li>Суровость к себе</li>
                <li>Чрезмерная критичность</li>
                <li>Склонность к перфекционизму</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      
      <section className="astrology-section">
        <h2>Совместимость с другими знаками</h2>
        <div className="card">
          <div className="compatibility-grid">
            <div className="compatibility-item high">
              <h3>Высокая совместимость</h3>
              <div className="compatibility-signs">
                <div>♉ Телец</div>
                <div>♍ Дева</div>
                <div>♏ Скорпион</div>
                <div>♓ Рыбы</div>
              </div>
            </div>
            <div className="compatibility-item medium">
              <h3>Средняя совместимость</h3>
              <div className="compatibility-signs">
                <div>♋ Рак</div>
                <div>♎ Весы</div>
                <div>♐ Стрелец</div>
                <div>♑ Козерог</div>
              </div>
            </div>
            <div className="compatibility-item low">
              <h3>Низкая совместимость</h3>
              <div className="compatibility-signs">
                <div>♈ Овен</div>
                <div>♊ Близнецы</div>
                <div>♌ Лев</div>
                <div>♒ Водолей</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="astrology-section">
        <h2>Лунный календарь на 4 января 2025</h2>
        <div className="card">
          <div className="moon-info">
            <div className="moon-phase">
              <div className="moon-circle"></div>
              <p>Убывающая луна</p>
              <p>12-й лунный день</p>
            </div>
            <div className="moon-description">
              <p>
                День рождения в 12-й лунный день наделяет человека интуицией, 
                творческим потенциалом и способностью к нестандартному мышлению.
              </p>
              <p>
                Люди, рожденные в этот день, обладают сильной интуицией и
                часто могут предвидеть будущие события.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Astrology; 